// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "field-2Xs_w";
var _4 = "name-3QHo8";
var _5 = "input-2jccR";
export { _1 as "__esModule", _2 as "mobile", _3 as "field", _4 as "name", _5 as "input" }
export default { "__esModule": _1, "mobile": _2, "field": _3, "name": _4, "input": _5 }
